<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgment">
<p style="text-align: center;margin-top:250px;">“If the world hates you, know that it has hated me before it hated you.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?350eb65e